import axios          from "axios";
import { EventBus }   from '@/shared/event-bus';
import commaNumber    from 'comma-number'
import moment         from 'moment'
import slug           from 'slug'

export default {

  computed: {

    getEnv() {
      return process.env.NODE_ENV;
    },

    getAppName() {
      return process.env.VUE_APP_NAME;
    },

    getAppEmail() {
      return process.env.APP_EMAIL;
    },

    getFrontendHost() {
      return process.env.VUE_APP_FRONTEND_URL;
    },

    getBackendHost() {
      return process.env.VUE_APP_API_URL;
    },

    getStripeKey() {
      return process.env.VUE_APP_STRIPE_API_KEY;
    },

    getJwt() {
      return localStorage.getItem('bp-broker-jwt');
    },

    getClientPrimaryApplicant() {
      for (let applicant of this.$store.state[this.$store.state.view + 'Module'].client.applicants) {
        if ("person" in applicant && applicant.person.isPrimary == 1) {
          return applicant
        }
      }
    },

    today() {
      return moment().toDate()
    },

    thisYear() {
      return moment().format("YYYY")
    },

    isPrimaryApplicant() {
      return this.$route.params.applicantId != null && this.$route.params.applicantId == this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].id
    },

    isUserThisBroker() {
      if(this.$store.state.view == 'broker' && this.$store.state.brokerModule.broker.id == this.$route.params.brokerId) {
        return true
      }

      return false
    },

    showMercuryOption() {

      if(this.$store.state[this.$store.state.view + 'Module'].broker.aggregator_id == 5 || this.$store.state[this.$store.state.view + 'Module'].broker.aggregator_id == 30) {

        if(this.$store.state[this.$store.state.view + 'Module'].broker.trial_ended == false) {
          return true
        }

        if(this.isUserAdmin(this.$store.state.user.email)) {
          return true
        }

        if(this.$store.state[this.$store.state.view + 'Module'].broker.subscription.stripe != null && 
           this.$store.state[this.$store.state.view + 'Module'].broker.subscription.stripe != null && 
           this.$store.state[this.$store.state.view + 'Module'].broker.subscription.stripe.name == 'pro') {
          return true
        }
      }

      return false
    }
  },

  methods : {

    showSuspendedModal() {
      this.$modal.show('suspended-modal')
    },

    addCommaToNumber(value) {
      let val = value.replace(/[^0-9\.]/g, '').replace(/^0([^\.])/g, '$1');

      // if (type == 'dollar_integer') {
      //   val = val.replace('.','');
      // } else {
        //Replace all but the last period
        if (val.indexOf('.') != -1) {
          var temp = val.split('.')
          var last = temp.pop()

          //Make sure that the last period has two numbers after it
          while (last.length > 2) {
            last = last.substr(last.length-2, 2);
          }

          val = temp.join('')+'.'+last;
        }
      // }

      //Comma format the number
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    isUserAdmin(email = null) {
      const emails = [
        'ericbae@gmail.com', 
        'ericbae@brokerpad.com.au', 
        'andrewg@brokerpad.com.au', 
        'zawmyohtut@gmail.com', 
        'davida@brokerpad.com.au', 
        'aggreatbatch@gmail.com',
        'support@brokerpad.com.au'
      ]

      if(email == null && this.$store.state.user != null && _.indexOf(emails, this.$store.state.user.email) > -1) {
        return true
      }

      if(email != null && _.indexOf(emails, email) > -1) {
        return true
      }

      return false
    },

    base_64_encode(value) {
      return btoa(value)
    },

    formatDate(value, from, to) {
      let m = null

      if(from == 'unix-seconds') {
        m = moment.unix(value)
      }

      else if(from == 'unix-milliseconds') {
        m = moment(value)
      }

      else {
        m = moment(value, from)
      }

      if(to == 'ago') {
        return m.fromNow()
      }

      else if(to == 'full') {
        return m.format("ddd, MMM Do YYYY, h:mm:ss a")
      }

      else {
        return m.format(to)
      }
    },

    roundTo2(num) {
      return Math.round(num * 100) / 100
    },

    getFutureDate(add, type) {
      return moment().add(add, type).toDate()
    },

    getFormattedDate(value, oldFormat, newFormat) {
      return moment(value, oldFormat).format(newFormat)
    },

    getUser(params, callback) {

      // let's check if there is client - set force to true if we want to get the latest data
      // note that we are getting the client from the given store MODULE
      if(params.force == null && this.$store.state.user != null) {
        callback(this.$store.state.user)
      }

      else {
        if(this.$store.state.isLoggedIn) {
          axios.get(process.env.VUE_APP_API_URL + '/api/user/detail', {
            params,
            headers : {
              'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt'),
            },
          }).then(response => {

            // if(this.$store.state.view == 'broker' && this.$store.state.user.id == response.data.user_id) || this.$store.state.view == 'client') {
              this.$store.commit('setUser', response.data)
            // }

            callback(response.data)
          }).catch(e => {

          })
        }

        else {
          callback({})
        }
      }
    },


    getBroker(params, callback) {

      // let's check if there is client - set force to true if we want to get the latest data
      // note that we are getting the client from the given store MODULE
      if(params.userId != null && params.force == null && this.$store.state[this.$store.state.view + 'Module'].broker != null) {
        callback(this.$store.state[this.$store.state.view + 'Module'].broker)
      }

      else {
        axios.get(process.env.VUE_APP_API_URL + '/api/broker/detail', {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {

          // only commit if the broker is same as the current broker
          if((this.$store.state.view == 'broker' && this.$store.state.user.id == response.data.user_id) || this.$store.state.view == 'client') {
            this.$store.commit(this.$store.state.view + "Module/setBroker", response.data)
          }

          callback(response.data)
        })
      }
    },

    /*
        Function to get the Document main categoires
     */
    getFileCategories(parameter, callback) {
      // GET: API call to get list of main categories
      axios.get(process.env.VUE_APP_API_URL + '/api/admin/document/categories', {
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      })
      .then(response => {
         callback(response.data.categories);
      })
      .catch(e => {
         callback(false);
      })
    },

    /*
        Function to get the the subcategories and file types required to upload for specific main category.
        Required parameter : category_id i.e the ID of the main category
     */
    getFileSubCategories(parameter, callback) {
        var categoryId = parameter.category_id;
        let params = {
          'category_id' : categoryId
        };
        // GET: API call to get sub categories and file types for the specific main category
        axios.get(process.env.VUE_APP_API_URL + '/api/admin/document/subcategories', {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        })
        .then(response => {
           callback(response.data.subcategories);
        })
        .catch(e => {
           callback(false);
        })
    },
    /*
        Function to download the file from server(s3 bucket).
        Required parameters: file object with 'id', 'original_file_name'

        return true/false in callback so that component accessing this method can recieve if request to download is successful or not.
     */
    downloadFile(parameter, callback) {
      var file = parameter.file_news;
      let params = {
        'files_new_id' : file.id
      };
      // GET: API call to get list of brokers
      axios.get(process.env.VUE_APP_API_URL + '/api/file/download', {
        params,
        responseType: 'blob',
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      })
      .then(response => {
         // API request is successfully made
         const url = window.URL.createObjectURL(new Blob([response.data]));
         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', file.original_file_name); //or any other extension
         document.body.appendChild(link);
         link.click();
         callback(true);
      })
      .catch(e => {
         callback(false);
      })
    },


    getClient(params, callback = null) {

      // let's check if there is client - set force to true if we want to get the latest data
      // note that we are getting the client from the given store MODULE
      if(params.force == null &&
         this.$store.state[this.$store.state.view + 'Module'].client != null &&
         this.$store.state[this.$store.state.view + 'Module'].client.id == params.clientId) {
        callback(this.$store.state[this.$store.state.view + 'Module'].client)
      }

      else {
        axios.get(process.env.VUE_APP_API_URL + '/api/client/detail', {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        })
        .then(response => {
          this.$store.commit(this.$store.state.view + "Module/setClient", response.data)

          if(callback != null) {
            callback(this.$store.state[this.$store.state.view + 'Module'].client)
          }
        })
        .catch(e => {

        })
      }
    },

    getApplicant(params, callback) {
      axios.get(process.env.VUE_APP_API_URL + '/api/applicant/detail', {
        params,
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      })
      .then(response => {
        //   this.$store.commit("setClient", response.data[0])
        callback(response.data)
      })
      .catch(e => {
        // this.errors.push(e)
      })
    },

    getApplicantName(applicant) {
      let name = ''

      // is it a person?
      if(applicant.person != null) {

        if(applicant.person.first_name != null && applicant.person.first_name.length > 0) {
          name += applicant.person.first_name + ' '
        }

        if(applicant.person.last_name != null && applicant.person.last_name.length > 0) {
          name += applicant.person.last_name
        }

        if(name.trim().length == 0) {
          name = '[None]'
        }
      }

      else if(applicant.company != null) {
        name += applicant.company.name != null && applicant.company.name.length > 0 ? applicant.company.name : '[None]'
      }

      else if(applicant.trust != null) {
        name += applicant.trust.name != null && applicant.trust.name.length > 0 ? applicant.trust.name : '[None]'
      }

      return name
    },

    getYoutubeVideoId(url) {
      var a, ampersandPosition, b, videoId;
      if ((url != null) && url.length > 0) {
        if (url.indexOf('youtu.be') > -1) {
          a = url.split('?')[0];
          b = a.split('/');
          return b[b.length - 1];
        } else if(url.indexOf('youtube.') > -1) {
          let arr = url.split('v=')
          if(arr.length > 1) {
            
            videoId           = url.split('v=')[1]
            ampersandPosition = videoId.indexOf('&')

            if(ampersandPosition !== -1) {
              videoId = videoId.substring(0, ampersandPosition)
            }
            
            return videoId
          }
        }
      }

      return null;
    },

    updatePerson(object, keyValueArr, callback = null) {
      let final = [];

      // only copy the properties that have changed their values
      for(let i=0; i < keyValueArr.length; i++) {
        if(object[keyValueArr[i].key] != keyValueArr[i].value) {
          object[keyValueArr[i].key] = keyValueArr[i].value
          final.push(keyValueArr[i])
        }
      }

      if(final.length > 0) {

        EventBus.$emit('set-autosave', true)

        axios.post(process.env.VUE_APP_API_URL + '/api/applicant/edit-person', {
          clientId   : this.$route.params.clientId,
          applicantId: object.applicant_id,
          keyValueArr: final
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)

          if(callback != null) {
            callback()
          }

          this.getClient({
            clientId: this.$route.params.clientId,
            force   : true
          })

        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    getThirdParty(params, callback) {
      axios.get(process.env.VUE_APP_API_URL + '/api/third-party/detail', {
        params,
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback(response.data)
      })
    },

    // third-party - solicitor, accountant, nearest relative
    // these used to be in a separate tab, but they are now dispersed throughout other tabs
    // but there is thirdparty table and controller and we will be updating
    // specific third-party at a time. Since they are all going to call the same
    // controller method, we are going to create a method here and re-use it
    updateThirdParty(object, type, key, value) {

      // only edit if the values are different
      if(object[key] != value) {

        EventBus.$emit('set-autosave', true)
        object[key] = value

        axios.post(process.env.VUE_APP_API_URL + '/api/third-party/save', {
          clientId : this.$route.params.clientId,
          type,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    updateAddress(object, key = null, value = null) {

      let goAndUpdate = (key == null && value == null) || (object[key] != value)

      if(goAndUpdate) {

        if(object != null) {
          object[key] = value
        }

        EventBus.$emit('set-autosave', true)

        if(key != null && value != null) {
          object[key] = value
        }

        axios.post(process.env.VUE_APP_API_URL + '/api/address/edit', {
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          addressId  : object.id,
          object     : object,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    updateResidence(object, key, value) {
      if(object[key] != value) {

        EventBus.$emit('set-autosave', true)
        object[key] = value

        axios.post(process.env.VUE_APP_API_URL + '/api/address/edit-residence', {
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          residenceId: object.id,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    updateUser(object, key, value, callback = null) {
      if(object[key] != value) {
        EventBus.$emit('set-autosave', true)

        // since user is in state, commit it - only if I am the user
        if(object.id == this.$store.state.user.id) {
          this.$store.commit('setUserProperty', {
            key,
            value
          })
        }

        this.apiPost({
          userId : object.id,
          key,
          value
        }, 'user/account', (res) => {
          EventBus.$emit('set-autosave', false)
          if(callback != null) {
            callback(res)
          }
        })
      }
    },

    updatePlannerUser(object, key, value) {
      if(object[key] != value) {
        EventBus.$emit('set-autosave', true)

        axios.post(process.env.VUE_APP_API_URL + '/api/planner/user/account', {
          userId: object.id,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    updatePlanner(object, key, value) {
      if(object[key] != value) {
        EventBus.$emit('set-autosave', true)
        object[key] = value

        axios.post(process.env.VUE_APP_API_URL + '/api/planner/save', {
          plannerId: object.id,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    updateBroker(object, key, value) {
      if(object[key] != value) {
        EventBus.$emit('set-autosave', true)
        object[key] = value

        // since we are updating broker, we have to commit it
        if(object.id == this.$store.state.brokerModule.broker.id) {
          this.$store.commit("brokerModule/setBrokerProperty", {
            key,
            value
          })
        } 

        else if(this.$route.name == 'broker-site-appearance') {
          this.$store.commit("brokerModule/setBrokerViaAdminProperty", {
            key,
            value
          })
        }

        axios.post(process.env.VUE_APP_API_URL + '/api/broker/save', {
          brokerId: object.id,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },

    showLoader(message) {
      EventBus.$emit('set-content-loading', {
        display: true,
        message: message,
      })
    },

    hideLoader() {
      EventBus.$emit('set-content-loading', {
        display : false
      })
    },

    logActivity(params) {
      axios.post(process.env.VUE_APP_API_URL + '/api/common/log-activity', params, {
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      })
    },

    uploadAttachment(formData, callback) {
      axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload-attachment', formData, {
        headers: {
          'Content-Type'  : 'multipart/form-data',
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback(response.data)
      }).catch(function(err) {

      });
    },

    deleteAttachment(params, callback) {
      axios.delete(process.env.VUE_APP_API_URL + '/api/broker/delete-attachment', {
        params,
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback()
      }).catch(e => {
        callback()
      })
    },

    commaNumber(value) {
      return commaNumber(value)
    },

    formatPhoneNumber(value) {
      var phone    = value.replace(/\s/g, '');
      phone        = phone.replace('+','');
      var length   = phone.length;
      var landline = phone.indexOf('02') == 0 || phone.indexOf('03') == 0 || phone.indexOf('07') == 0 || phone.indexOf('08') == 0;

      if(
          (length == 8 && phone.indexOf('61') != 0 && phone.indexOf('04') != 0 && !landline) ||
          (length > 4 && length < 8 && (phone.indexOf('9') == 0 || phone.indexOf('8') == 0))
        ) {

        return phone.substring(0,4)+' '+phone.substring(4);
      }

      else if(
        (length == 10 && phone.indexOf('61') != 0) ||
        (length > 4 && length < 10 && phone.indexOf('04') == 0) ||
        (length > 2 && length < 10 && landline)) {

        if(landline) {

          if(length < 7) {
            return phone.substring(0,2)+' '+phone.substring(2);
          }

          else {
            return phone.substring(0,2)+' '+phone.substring(2,6)+' '+phone.substring(6);
          }
        }

        else {
          if(length < 8) {
            return phone.substring(0,4)+' '+phone.substring(4);
          }

          else {
            return phone.substring(0,4)+' '+phone.substring(4,7)+' '+phone.substring(7);
          }
        }
      }

      else if(length == 11 || (length > 2 && length < 11 && phone.indexOf('61') == 0)) {

        if(phone.indexOf('612') == 0) {

          if(length < 4) {
            return phone;
          }

          else if(length < 8) {
            return phone.substring(0,3)+' '+phone.substring(3);
          }

          else {
            return phone.substring(0,3)+' '+phone.substring(3,7)+' '+phone.substring(7);
          }
        }

        else {
          if(length < 6) {
            return phone.substring(0,2)+' '+phone.substring(2);
          }

          else if(length < 9) {
            return phone.substring(0,2)+' '+phone.substring(2,5)+' '+phone.substring(5);
          }

          else {
            return phone.substring(0,2)+' '+phone.substring(2,5)+' '+phone.substring(5,8)+' '+phone.substring(8);
          }
        }
      }
      return value;
    },

    updateCompany(object, key, value) {
      if(object[key] != value) {
        object[key] = value
        EventBus.$emit('set-autosave', true)

        axios.post(process.env.VUE_APP_API_URL + "/api/applicant/edit-company", {
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          companyId  : object.id,
          key,
          value
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          EventBus.$emit('set-autosave', false)
        }).catch(e => {
          EventBus.$emit('set-autosave', false)
        })
      }
    },


    downloadAllAsZip(clientId, name) {
      EventBus.$emit('close-client-actions')
      EventBus.$emit('set-content-loading', {
        display    : true,
        message    : 'Downloading',
        leftPadding: 0,
        center     : true
      })
      
      axios.post(process.env.VUE_APP_API_URL + '/api/document/download-all-as-zip', {
        clientId
      }, {
        responseType: 'blob',
        headers     : {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        this.hideLoader()
        // get the URL to download the zip file, then embed this URL as a link in the body
        // and we manually click on the link
        let link  = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        link.setAttribute('download', slug(this.getAppName + ' ' + name, {lower: true}) + '.zip')
        document.body.appendChild(link)
        link.click()

        EventBus.$emit('notification-event', {
          'type'   : 'success', 
          'message': 'Files successfully downloaded.'
        })
      })
    },




    addNewClient() {
      this.showLoader("Adding a new client...")
      this.apiPost({}, 'client/create', (data) => {
        this.hideLoader()
        this.$router.push({
          name  : 'application-applicant-profile',
          params: {
            clientId   : data.client.id,
            applicantId: data.applicant.id
          }
        })
      })
    },

    logout() {
      this.$store.commit('setIsLoggedIn', false)
      this.$store.commit('setUser', null)
      this.$store.commit("brokerModule/setBroker", null)
      this.$store.commit("clientModule/setBroker", null)
      localStorage.removeItem("bp-broker-jwt")

      if(this.$store.state.view == 'broker') {
        this.$router.push({ name : 'auth-login' })
      } else {
        this.$router.push({ name : 'client-logged-out' })
      }
    },

    isUserThisPlanner() {
      if(this.$store.state.view == 'planner' && this.$store.state.plannerModule.planner.id == this.$route.params.plannerId) {
        return true
      }

      return false
    },

    apiGet(params, url, callback) {
      axios.get(process.env.VUE_APP_API_URL + '/api/' + url, {
        params,
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback(response.data)
      }).catch(e => {
        // callback()
        // this.errors.push(e)
      })
    },

    apiPost(params, url, callback) {
      axios.post(process.env.VUE_APP_API_URL + '/api/' + url, params, {
        headers : {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback(response.data)
      }).catch(e => {
        console.log(e)
        // this.loading = false;
      })
    },

    apiDelete(params, url, callback) {
      axios.delete(process.env.VUE_APP_API_URL + '/api/' + url, {
        params,
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        callback()
      }).catch(e => {
        // this.loading = false;
      })
    },
  }
}